import { VfModal } from '@vfit/shared/components';
import { useState } from 'react';
import * as S from './detailsChecklist.style';
import { Svg } from '@vfit/shared/atoms';
import { purify } from '@vfit/shared/themes';
import { OptionText } from './detailsChecklist.style';

export const DetailsChecklist = ({ checkList }: IDetailsChecklist) => {
  return (
    <>
      {checkList &&
        checkList.map((option) => (
          <ListElement
            optionText={option.optionText}
            optionMoreDetails={option.optionMoreDetails}
          />
        ))}
    </>
  );
};

const ListElement = ({ optionText, optionMoreDetails }: Option) => {
  const [isOpenModal, setOpenModal] = useState(false);
  const purifyElement = (text: string) => {
    return purify([text]);
  };
  return (
    <S.ListElement>
      <S.CheckMark>
        <Svg name={'tickV2'} height={30} width={18} />{' '}
      </S.CheckMark>
      <OptionText
        dangerouslySetInnerHTML={{ __html: purifyElement(optionText || '')?.[0] || '' }}
      />
      {optionMoreDetails && (
        <>
          <S.CircleSmall onClick={() => setOpenModal(true)}>
            <Svg name="info" height={16} width={16} />
          </S.CircleSmall>
          <VfModal isOpen={isOpenModal} handleClose={() => setOpenModal(false)}>
            <div
              dangerouslySetInnerHTML={{
                __html: purifyElement(optionMoreDetails || '')?.[0] || '',
              }}
            />
          </VfModal>
        </>
      )}
    </S.ListElement>
  );
};

type IDetailsChecklist = {
  checkList: Option[];
};
type Option = {
  optionText?: string;
  optionMoreDetails?: string;
};

